import { getBankAccount, createAccount, updateBankAccount, getSimpleBankAccount } from '@/api/bankAccount'
import Vue from 'vue'

const state = {
  bankAccount: [],
  simpleBankAccount: [],
  totalCounts: 0,
}

const actions = {
  async getBankAccountAction({ commit }, payload) {
    try {
      const res = await getBankAccount(payload)
      commit('SET_RECEIVE_ACCOUNT', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async getSimpleBankAccountAction({ commit }, payload) {
    try {
      const res = await getSimpleBankAccount(payload)
      commit('SET_SIMPLE_RECEIVE_ACCOUNT', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async createAccountAction({ commit }, payload) {
    try {
      const newAccount = await createAccount(payload);
      commit('ADD_ACCOUNT', newAccount.data)
    } catch (error) {
      throw error.message
    }
  },

  async updateBankAccountAction({ commit }, payload) {
        try {
            const receive = await updateBankAccount(payload.id, payload.data)
            commit("UPDATE_RECEIVE_ACCOUNT", receive.data)
            return receive.data
        } catch (error) {
            throw error.message
        }
  },
}

const mutations = {
  SET_RECEIVE_ACCOUNT(state, payload) {
    state.bankAccount = payload.receiveList
    state.totalCounts = payload.totalCounts
  },
  SET_SIMPLE_RECEIVE_ACCOUNT(state, payload) {
    state.simpleBankAccount = payload.receiveList
    state.totalCounts = payload.totalCounts
  },
  ADD_ACCOUNT(state, newAccount) {
    state.bankAccount.unshift(newAccount)
    state.totalCounts++
  },

  UPDATE_RECEIVE_ACCOUNT(state, receive) {
    Vue.set(state.bankAccount, state.bankAccount.findIndex(x => x._id === receive._id), receive)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}